import { NAMED_INSURED_STATUS } from '@/constants';

export class NamedInsuredEntity {
  constructor({
    id,
    insuredId = '',
    name = '',
    email = '',
    status = NAMED_INSURED_STATUS.active,
    isDefault = false,
    deactivatedDate = null,
    addresses = [],
    createdAt = new Date(),
    updatedAt = new Date(),
    deleted = false,
  }) {
    this.id = id;
    this.insuredId = insuredId;
    this.name = typeof name === 'string' ? name : '';
    this.email = typeof email === 'string' ? email : '';
    this.status = status;
    this.isDefault = isDefault;
    this.deactivatedDate = deactivatedDate;
    this.addresses = addresses;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.deleted = deleted;
  }
}
